export const MaterialCategoria = Object.freeze({
  ANILOX: 32,
  CINTA_BIFAZ: 3,
});
